import React, { useState } from "react";
import { Modal, Button, Tag, Divider, notification } from "antd";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHome, faPlaneDeparture } from "@fortawesome/free-solid-svg-icons";
import $axios from "../../services/axios";

const RepaymentModal = ({ visible, onClose, data, airports, isRepayment = true }) => {
  const [loading, setLoading] = useState(false);
  if (!data) return null;

  const booking = data.orderplanebookings[0];
  const passengers = data?.orderplanepassengers || [];

  const startpointName = (airports || []).find(
    (air) => air.code === data?.orderplanebookings?.[0]?.fromairport || "",
  )?.name;
  const endpointName = (airports || []).find(
    (air) => air.code === data?.orderplanebookings?.[0]?.toairport || "",
  )?.name;
  // console.log(booking, "booking");
  const rePayment = async (item) => {
    // Send orderCode for IOS
    if (
      window.webkit &&
      window.webkit.messageHandlers &&
      window.webkit.messageHandlers.NativeJavascriptInterface
    ) {
      // Chuyển đổi dữ liệu thành chuỗi JSON và gửi qua Swift
      window.webkit.messageHandlers.NativeJavascriptInterface.postMessage({
        orderCode: item.ordercode,
      });
    } else {
      console.error(
        "NativeJavascriptInterface không tồn tại hoặc không được hỗ trợ."
      );
    }
    // Send orderCode for Android
    if (window.webkit !== undefined) {
      if (window.webkit.messageHandlers.appInterface !== undefined) {
        window.webkit.messageHandlers.appInterface.postMessage(
          JSON.stringify({
            orderCode: item.ordercode,
          })
        );
      }
    }
    if (window.appInterface !== undefined) {
      window.appInterface.postMessage(
        JSON.stringify({
          orderCode: item.ordercode,
        })
      );
    }
    // window.location.href = bookingInfo.paymentUrl;

  };

  const formatPassengerType = (type) => {
    switch (type) {
      case "ADT":
        return <Tag color="orange">Người lớn</Tag>;
      case "CHD":
        return <Tag color="orange">Trẻ em</Tag>;
      case "INF":
        return <Tag color="orange">Em bé</Tag>;
      default:
        return <Tag>{type}</Tag>;
    }
  };

  return (
    <Modal
      open={visible}
      footer={null}
      onCancel={onClose}
      closable
      className="rounded-2xl repayment-modal"
    >
      <div>
        {/* Header */}
        <div className="bg-primary text-white p-3  text-left rounded-tl-md rounded-tr-md flex gap-4 items-center">
          <div className="w-[32px] h-[32px]  rounded-full bg-primary-light flex items-center justify-center">
            {" "}
            <FontAwesomeIcon icon={faPlaneDeparture} />
          </div>
          <div>
            {
              isRepayment ? (
                <>
                  <p className="font-semibold text-[16px]">
                    Bạn còn 1 đơn chưa thanh toán
                  </p>
                  <p className="text-[14px]">Bạn có muốn thanh toán không?</p>
                </>
              ) : (
                <>
                  <p className="font-semibold text-[16px]">Xác nhận thông tin</p>
                  <p className="text-[14px]">
                    Vui lòng kiểm tra kỹ trước khi thanh toán
                  </p>
                </>
              )
            }
          </div>
        </div>
        <div className="p-3">
          {/* Thông tin đơn hàng */}
          <div className="text-[14px] font-bold uppercase text-gray-500 mb-2">
            Thông tin đơn hàng
          </div>
          <div className="grid grid-cols-2 gap-3 mb-4">
            <Tag
              color="#f8fafc"
              className=" rouned-lg border border-solid border-sky-100 col-span-2"
            >
              {" "}
              <div className="p-3 border rounded-lg">
                <p className="text-gray-500 text-xs mb-1 uppercase">
                  Mã đặt chỗ
                </p>
                <Tag color="green">
                  <span className="text-sm">{data?.ordercode}</span>
                </Tag>
              </div>
            </Tag>

            <Tag color="#f8fafc">
              {" "}
              <div className="p-3 border rounded-lg">
                <p className="text-gray-500 text-xs uppercase mb-1">
                  Hành trình
                </p>
                <p className="font-semibold text-wrap text-black text-sm">
                  {startpointName} - {endpointName}
                </p>
              </div>
            </Tag>
            <Tag color="#f8fafc">
              {" "}
              <div className="p-3 border rounded-lg">
                <p className="text-gray-500 text-xs mb-1 uppercase ">
                  Tổng thanh toán
                </p>
                <p className="text-black font-bold text-sm">
                  {data.amount.toLocaleString()} VND
                </p>
              </div>
            </Tag>
            {/* <Tag color="gold">
              {" "}
              <div className="p-3 border rounded-lg">
                <p className="text-gray-500 uppercase text-xs">
                  Hạn thanh toán
                </p>
                <p className="font-semibold text-sm">
                  {moment(booking?.expiryDate).format("HH:mm, DD/MM/YYYY")}
                </p>
              </div>
            </Tag> */}
          </div>

          {/* Hành khách */}
          <div className="mb-4">
            <div className="text-[14px] font-bold uppercase text-gray-500 mb-2">
              Hành khách
            </div>
            {passengers.map((p, idx) => (
              <div
                key={p.id}
                className="flex items-center justify-between border border-solid p-2 rounded-lg mb-2 border-sky-100"
              >
                <div className="flex gap-2 items-center">
                  <div className="w-[32px] h-[32px] rounded-full bg-[#f1f5f9] flex items-center justify-center text-center">
                    {" "}
                    <span className="font-semibold">{idx + 1}</span>
                  </div>
                  <span>
                    {p.surname} {p.givenname}
                  </span>
                </div>
                {formatPassengerType(p.passengertype)}
              </div>
            ))}
          </div>

          {/* Liên hệ */}
          <div className="mb-4">
            <div className="text-[14px] font-bold uppercase text-gray-500 mb-2">
              Liên hệ
            </div>
            <div className="p-3 border rounded-lg bg-gray-50 mb-3 border-sky-100 border-solid">
              <p className="text-gray-500 text-xs">HỌ VÀ TÊN</p>
              <p className="font-semibold text-sm">{data.fullnamecontact}</p>
            </div>
            <div className="grid grid-cols-2 gap-3">
              <div className="p-3 border rounded-lg bg-gray-50 border-solid border-sky-100">
                <p className="text-gray-500 text-xs uppercase">Số điện thoại</p>
                <p className="font-semibold text-sm">{data.phonecontact}</p>
              </div>
              <div className="p-3 border rounded-lg bg-gray-50 border-solid border-sky-100">
                <p className="text-gray-500 text-xs uppercase">Email</p>
                <p className="font-semibold text-sm">{data.emailcontact}</p>
              </div>
            </div>
          </div>

          {/* Footer */}
          <Divider />
          <div className="flex justify-center gap-4">
            <Button Button onClick={onClose} size="large" className="w-1/2">
              <FontAwesomeIcon icon={isRepayment ? faHome : null} />
              <span className="text-gray-500">{isRepayment ? "Về Trang chủ" : "Hủy"}</span>
            </Button>
            <Button
              type="primary"
              size="large"
              className="w-1/2"
              loading={loading}
              onClick={() => {
                rePayment(data);
              }}
            >
              Thanh toán
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default RepaymentModal;
